const text = `
<p>Ce projet a demandé de très nombreuses heures de travail. Il n’aurait jamais vu le jour sans <a href="https://www.arthurcapo.fr">Arthur Capo</a>, qui a développé le générateur et le site internet avec une patience infinie.<p/>
<p>DORÉBU existe grâce à <a href="http://pageperso.lif.univ-mrs.fr/~frederic.bechet/download.html">lia_phon</a>, une bibliothèque open-source crée par Frédéric Béchet permettant de phonétiser la langue française, pourtant si complexe. <p/>
<p>Je remercie également toutes les personnes qui ont pris le temps de me conseiller et faire des retours sur ce projet.</p>
`;

const title = 'REMERCIEMENTS';

export default { text, title };
